import {
  ShowContextProvider,
  SimpleShowLayout,
  TextField,
  Labeled,
  useEditController,
  BooleanField,
} from "react-admin";
import { useParams } from "react-router-dom";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";

export const EducationalInstitutionShow = () => {
  const { id } = useParams();
  const controller: any = useEditController({
    resource: "educational-institutions/crud",
    id,
  });
  return (
    <ShowContextProvider value={controller}>
      <SimpleShowLayout className="RaShowClass">
        <PageTopBreadcrumb
          title="Instituição de Ensino"
          firstPath="/#/educational-institutions/crud"
          secondTitle="Visualizando"
          thirdTitle={controller && controller.record && controller.record.name}
          actionType="edit"
        />
        <Card sx={{ padding: 2, marginBottom: 3 }}>
          <CardHeader title="Instituição de Ensino" />
          <CardContent>
            <Grid container spacing={0.5}>
              <Grid item xs={12}>
                <Stack>
                  <Labeled>
                    <TextField source="id" />
                  </Labeled>
                  <Labeled>
                    <TextField source="name" label="Nome" />
                  </Labeled>
                  <Labeled>
                    <BooleanField source="reviewed" label="Revisado" />
                  </Labeled>
                </Stack>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </SimpleShowLayout>
    </ShowContextProvider>
  );
};
